import React from 'react'

const DemoPage = () => {
    return (
        <div>
            <div className='w-[30%] mx-auto flex justify-center items-center mt-16 mb-10'>
                <img src='/dashboard.png' alt='demo' />
            </div>
            <p className='text-3xl font-medium text[#000000] text-center '>"Demo" - allows users to access a demonstration of the Ampera analytics platform, providing an overview of its features and functionalities.</p>
        </div>
    )
}

export default DemoPage
